import { AssetThirdPartyConstraintBase } from './base/asset-third-party-constraint-base';

export class AssetThirdPartyConstraint extends AssetThirdPartyConstraintBase { }